import { CurrentOrderState } from 'src/types/redux';
import {
  ADD_CURRENT_ORDER,
  CLEAR_CURRENT_ORDER,
  FETCH_TAXES_ORDER,
  FETCH_USERS_ORDER,
  ADD_CURRENT_USER,
  INCREASE_QUANTITY_CURRENT_ORDER,
  DECREASE_QUANTITY_CURRENT_ORDER,
  FETCH_DELIVERY_CHARGE_ORDER,
  CurrentOrderActionType,
  ADD_CURRENT_ORDER_INFO,
} from '../types/currentOrderType';
import { createOrderItem } from 'src/types/model';

const initialState: CurrentOrderState = {
  orders: {
    businessId: '',
    type: '',
    tableId: '',
    tableName: '',
    userId: '',
    origin: 'pos_device',
    deliveryCharge: 0,
    items: [],
    promo: null,
    dataOrders: null,
  },
  orderInfo: null,
  taxes: [],
  users: [],
  currentUser: null,
  deliveryCharge: 0,
};

export const currentOrderReducer = (
  state = initialState,
  action: CurrentOrderActionType
): CurrentOrderState => {
  switch (action?.type) {
    case CLEAR_CURRENT_ORDER:
      return {
        ...state,
        orders: {
          businessId: '',
          type: '',
          tableId: '',
          tableName: '',
          userId: '',
          origin: 'pos_device',
          deliveryCharge: 0,
          items: [],
          promo: null,
          dataOrders: null,
        },
        currentUser: null,
      };
    case FETCH_TAXES_ORDER:
      return {
        ...state,
        taxes: action?.payload,
      };
    case FETCH_DELIVERY_CHARGE_ORDER:
      return {
        ...state,
        deliveryCharge: action?.payload,
      };
    case FETCH_USERS_ORDER:
      return {
        ...state,
        users: action?.payload,
      };
    case ADD_CURRENT_ORDER:
      return {
        ...state,
        orders: action?.payload,
      };
    case ADD_CURRENT_ORDER_INFO:
      return {
        ...state,
        orderInfo: action?.payload,
      };
    case ADD_CURRENT_USER:
      return {
        ...state,
        currentUser: action?.payload,
      };
    case INCREASE_QUANTITY_CURRENT_ORDER:
      return {
        ...state,
        orders: {
          ...state.orders,
          items: state.orders.items.map((item) => {
            const idToCheck = item.identifierId || item.variantId;

            if (idToCheck === action?.payload.id) {
              return {
                ...item,
                quantity: item.quantity + 1,
              };
            }

            return item;
          }),
        },
      };
    case DECREASE_QUANTITY_CURRENT_ORDER:
      return {
        ...state,
        orders: {
          ...state.orders,
          items: state.orders.items
            .map((item) => {
              const idToCheck = item.identifierId || item.variantId;
              if (idToCheck === action?.payload.id) {
                if (item?.decreaseLimit !== undefined) {
                  if (item.quantity === item?.decreaseLimit) {
                    return item;
                  }
                }

                const newQuantity = Math.max(item.quantity - 1, 0);

                return newQuantity > 0
                  ? { ...item, quantity: newQuantity }
                  : null;
              }

              return item;
            })
            .filter((item) => item !== null) as createOrderItem[],
        },
      };
    default:
      return state;
  }
};
